import axiosAPI from 'axios';
import * as loader from "../components/loader";

const axios = axiosAPI.create({
    baseURL: process.env.REACT_APP_API_URL
})

axios.interceptors.request.use(request => {
    const systemId = localStorage.getItem('BOR_SYSTEM_ID');
    if (systemId) {
        request.headers['examSoftwareSystemId'] = systemId;
    }

    return request;
});

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    console.log(error?.response);
    if (error?.response?.data?.errorCode === 900) {
        loader.notification(false, "The exam is already submitted. We are redirecting you to login page")
        setTimeout(() => {
            localStorage.clear();
            window.location.href = "/"
        }, 1500);
        // return Promise.reject(error);
    }
    else
        return Promise.reject(error);
});


export { axios };